"use strict";module.exports=function(it){return it===null||it===undefined};